import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { ADD_PACS, ECHO_ENDPOINT, UPDATE_PACS } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import EchoAlert from "../EchoAlert";
import "../Modal/Modal.css";
import "./Modal.css";
import { fetchTimezones } from "./Utility";

const PacsModal = (props) => {
  const { editData } = props;
  const [name, setName] = React.useState("");
  const [aeid, setAeid] = React.useState("");
  const [priority, setPriority] = useState("");
  const [port, setPort] = React.useState("");
  const [ip, setIP] = React.useState("");
  const [id, setId] = React.useState("");
  const [TimeZoneData, setTimeZoneData] = useState();
  const [timeZone, setTimeZone] = useState();
  const [error, seterror] = useState();
  const [echoAlert, setEchoAlert] = useState(false);
  const [circularProgress, displayCircularProgress] = React.useState(false);
  const [echostatus, setEchoStatus] = useState("");

  useEffect(() => {
    const result = async () => {
      const TimezoneResponse = await fetchTimezones();
      setTimeZoneData(TimezoneResponse?.data?.timezone_list);
    };

    result();
  }, []);
  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setAeid(editData.ae_title);
      setPort(editData.port);
      setIP(editData.ip);
      setId(editData.id);
      setPriority(editData.priority);
      setTimeZone({
        value: editData.timezone,
        label: editData.timezone,
      });
    }
  }, [editData]);

  useEffect(() => {
    if (circularProgress && echostatus === "") {
      displayCircularProgress(true);
    } else {
      displayCircularProgress(false);
    }
  }, [echostatus, circularProgress]);

  const checkEchoStatus = async () => {
    if (ip == "" || aeid == "" || port == "") return;
    if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
      setIP("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    try {
      displayCircularProgress(true);
      const response = await axiosInstance.post(
        `${ECHO_ENDPOINT}`,
        {
          ip: ip,
          port: port,
          ae_title: aeid,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      setEchoStatus(response.data.message);
      setEchoAlert(true);
    } catch (error) {
      setEchoStatus("Invalid Input");
      setEchoAlert(true);
    }
  };

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const TimezoneChange = (e) => {
    setTimeZone(e);
  };

  const timeZoneConfigurations = TimeZoneData?.map((item) => ({
    value: item,
    label: item,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !aeid || !port || !ip || !timeZone) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }
    if (!/^\d+$/.test(port)) {
      // Port is not a valid number
      setPort("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }
    if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
      // IP is not a valid IP address (IPv4)
      setIP("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    // const isNumeric = /^[0-9]+$/;

    //   if (!isNumeric.test(priority)) {

    //     console.log(isNumeric.test(priority))
    //     console.log(priority)

    //   seterrorforpriority(true);
    //   setTimeout(() => {
    //     seterrorforpriority(false);
    //   }, 2000);
    //   return;
    //   }

    const SendData = async () => {
      try {
        const response = await axiosInstance.post(
          `${ADD_PACS}`,
          {
            name: name,
            ae_title: aeid,
            port: port,
            ip: ip,
            timezone: timeZone && timeZone.value,
            priority: priority == "" ? 0 : priority,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setName("");
        setAeid("");
        setIP("");
        setPort("");
        setPriority("");
        setTimeZone("");
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const handleEditSubmit = async (e) => {
    if (!name || !aeid || !port || !ip || !timeZone) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    if (!/^\d+$/.test(port)) {
      // Port is not a valid number
      setPort("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }
    if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
      // IP is not a valid IP address (IPv4)
      setIP("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      try {
        const response = await axiosInstance.put(
          `${UPDATE_PACS}`,
          {
            id: id,
            name: name,
            ae_title: aeid,
            port: port,
            ip: ip,
            timezone: timeZone && timeZone.value,
            priority: priority,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={props.ModalState}
        onClose={props.handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="h5 font-weight-bold  mt-2">Add PACS</div>
            <IconButton
              className="text-light"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="mt-3 rounded">
            <div className="sort_search_header_field">Name*</div>
            <div className="mt-1">
              <input
                required
                className="text-input-modal"
                id="name"
                label="Name"
                onChange={(e) => setName(e.target.value.trimStart())}
                value={name}
              />{" "}
              {!name && error && (
                <span className="errorStyles">NAME Required</span>
              )}
            </div>
            <div className=" mt-1 ">
              <div className="sort_search_header_field">AE Title*</div>
              <input
                required
                id="aeid"
                label="AE ID"
                onChange={(e) => setAeid(e.target.value.trimStart())}
                className="text-input-modal"
                value={aeid}
              />
              {!aeid && error && (
                <span className="errorStyles">AE ID Required</span>
              )}
            </div>
            <div className=" mt-1">
              <div className="sort_search_header_field">Port*</div>
              <input
                required
                id="port"
                type="number"
                label="Port Number"
                min={0}
                onChange={(e) => setPort(e.target.value.trimStart())}
                className="text-input-modal"
                value={port}
              />
              {!port && error && (
                <span className="errorStyles">PORT Required</span>
              )}
            </div>
            <div className="mt-1">
              <div className="sort_search_header_field">IP Address*</div>
              {!editData && (
                <input
                  style={{ width: "80%" }}
                  required
                  className="text-input-modal"
                  id="ip"
                  label="IP Address"
                  onChange={(e) => setIP(e.target.value.trimStart())}
                  value={ip}
                />
              )}
              {editData && (
                <input
                  required
                  className="text-input-modal"
                  id="ip"
                  label="IP Address"
                  onChange={(e) => setIP(e.target.value.trimStart())}
                  value={ip}
                />
              )}
              {circularProgress && (
                <CircularProgress
                  style={{ marginLeft: "20px", height: "20px", width: "20px" }}
                />
              )}
              {!editData &&
                !circularProgress &&
                (ip === "" || aeid === "" || port === "") && (
                  <button
                    className="btn-class"
                    disabled
                    style={{ marginLeft: "5px", backgroundColor: "grey" }}
                    onClick={checkEchoStatus}
                  >
                    ECHO
                  </button>
                )}
              {!editData &&
                !circularProgress &&
                ip !== "" &&
                aeid !== "" &&
                port !== "" && (
                  <button
                    className="btn-class"
                    style={{ marginLeft: "5px" }}
                    onClick={checkEchoStatus}
                  >
                    ECHO
                  </button>
                )}
              <EchoAlert
                echoAlert={echoAlert}
                setEchoAlert={setEchoAlert}
                type="C-ECHO"
                value={aeid}
                result={echostatus}
                setPingStatus={setEchoStatus}
              />
              {!ip && error && <div className="errorStyles">IP Required</div>}
            </div>
            <div className="mt-3">
              <div className="sort_search_header_field">Time Zone*</div>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "black",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
                isClearable={true}
                placeholder="Select TimeZone"
                name="TIMEZONE"
                options={timeZoneConfigurations}
                onChange={TimezoneChange}
                value={timeZone}
              />
              {!timeZone && error && (
                <span className="errorStyles">Time Zone Required</span>
              )}
            </div>
            <div className="mt-1">
              <div className="sort_search_header_field">Priority</div>
              <input
                placeholder="(value from 0 to 9)"
                className="text-input-modal"
                id="ip"
                type="number"
                min={1}
                max={9}
                label="Priority"
                onChange={(e) => setPriority(e.target.value.trimStart())}
                value={priority}
              />
              {/* { errorforpriority && <span className="errorStyles">provide Valide Priority</span>} */}
            </div>
            <div className="mt-1 text-center">
              <button
                className="btn-class"
                onClick={editData ? handleEditSubmit : handleSubmit}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default PacsModal;
